import React from 'react'

const NoContents = () => {
  return (
    <div className="flex-container">
      <div className="cont-none">
        <span>등록된 내용이 없습니다</span>
      </div>
    </div>
  )
}

export default NoContents
